import gql from "graphql-tag";

export const MY_TIME_GET_ALL_REQUESTS_BADGE_COUNTER = gql`
  query allRequestsBadgeCounter($startDate: Date!, $endDate: Date!) {
    allRequestsBadgeCounter(startDate: $startDate, endDate: $endDate)
  }
`;
